;(function () {
  'use strict'

  angular
    .module('contrast.services.key.status')
    .factory('keyStatusService', keyStatusService)

  function keyStatusService($timeout) {
    'ngInject'

    var _delay = 500
    var _defaultFlashTimes = 2

    var service = {
      changeKeyStatusToRotated: changeKeyStatusToRotated
    }

    return service

    function changeKeyStatusToRotated(keyStatus, flashTimes) {
      if (typeof flashTimes === 'undefined') {
        flashTimes = _defaultFlashTimes
      }

      if (!keyStatus.rotated) {
        keyStatus.rotated = true
        flashTimes = flashTimes - 1
        _startTimeout(keyStatus, flashTimes)
      } else {
        keyStatus.rotated = false
        if (flashTimes > 0) {
          _startTimeout(keyStatus, flashTimes)
        }
      }
    }

    function _startTimeout(keyStatus, flashTimes) {
      $timeout(function () {
        changeKeyStatusToRotated(keyStatus, flashTimes)
      }, _delay)
    }
  }
})()
